module.exports = __webpack_public_path__ + "img/icon-status-error.34477e86.svg";